import { IconCardsOutline18 as CardsIcon } from "nucleo-ui-outline-18"

import type { SlashCommandDefinition } from "../types"
import { iconClassName } from "../constants"

export const tabsCommand: SlashCommandDefinition = {
	key: "tabs",
	title: "Tabs",
	icon: <CardsIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertTabs().run()
	},
	group: "blocks",
	aliases: ["tab", "tabs", "panels", "switcher"],
}
